module.exports = __webpack_public_path__ + "img/eraser.8101ad8a.svg";